import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d28b126"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../assets/logo.png"
}, null, -1))
const _hoisted_2 = {
  class: "inner_box",
  style: {"height":"830px"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll_body" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "signatory_list_block",
        onWheel: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.signatory_scroll && _ctx.signatory_scroll(...args)))
      }, [
        _createElementVNode("div", {
          class: "signatory_content_block",
          style: _normalizeStyle({ marginTop: _ctx.signatory_y_pos.val + 'px' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doc_list, (input, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "signatory_block",
              key: index
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "blue_next_btn active_btn",
                onClick: ($event: any) => (_ctx.open_doc(input.id, input.hash)),
                style: {"margin-left":"10px","margin-bottom":"8px","text-align":"left","padding-left":"15px","padding-right":"15px","width":"1000px"}
              }, _toDisplayString(input.name), 9, _hoisted_3)
            ]))
          }), 128))
        ], 4),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "scroll unselectable",
          style: _normalizeStyle({ top: 0 + _ctx.signatory_y_pos.val1 + 'px' }),
          onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signatory_drag && _ctx.signatory_drag(...args))),
          onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signatory_drag && _ctx.signatory_drag(...args)))
        }, _hoisted_5, 36)), [
          [_directive_touch, _ctx.signatory_drag, "drag"],
          [_directive_touch, _ctx.signatory_drag, "press"],
          [_directive_touch, _ctx.signatory_drag, "release"]
        ])
      ], 32),
      _createElementVNode("button", {
        type: "button",
        class: "white_s_btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.go_back())),
        style: {"margin-left":"20px"}
      }, " Назад ")
    ])
  ], 64))
}